import { PermissionsTypes } from './actionTypes';

const INIT_STATE = {
  permissions: [],
  permissionsDetail: {},
  permissionsAdd: {},
  CountItems: 0,
  deleteId: undefined,
  permissionsUpdate: {},
  error: {},
  success: '',
  isLoading: false,
};

const Permissions = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    //GET CLIENT
    case PermissionsTypes.GET_PERMISSIONS:
      return {
        ...state,
        isLoading: true,
      };
    case PermissionsTypes.GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.payload.permisosData,
        CountItems: action.payload.CountItems,
        permissionsAdd: {},
        isLoading: false,
      };
    case PermissionsTypes.GET_PERMISSIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        permissions: [],
        permissionsAdd: {},
        isLoading: false,
      };

    case PermissionsTypes.GET_PERMISSIONS_DETAIL_SUCCESS:
      return {
        ...state,
        permissionsDetail: action.payload,
      };

    case PermissionsTypes.GET_PERMISSIONS_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case PermissionsTypes.ADD_PERMISSIONS:
      return {
        ...state,
        isLoading: true,
      };
    case PermissionsTypes.ADD_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissionsAdd: action.payload,
      };
    case PermissionsTypes.ADD_PERMISSIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case PermissionsTypes.DELETE_PERMISSIONS:
      return {
        ...state,
        isLoading: true,
      };
    case PermissionsTypes.DELETE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        deleteId: action.payload,
      };
    case PermissionsTypes.DELETE_PERMISSIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case PermissionsTypes.UPDATE_PERMISSIONS:
      return {
        ...state,
        isLoading: true,
      };

    case PermissionsTypes.UPDATE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissionsUpdate: action.payload,
      };
    case PermissionsTypes.UPDATE_PERMISSIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      break;
  }
  return state;
};

export default Permissions;
